// extracted by mini-css-extract-plugin
export default {"container":"L_DVv4iuJI3FG0vHvIUv"};